import React from "react";

const Buscar = ({ search, setSearch }) => {
  const handleSubmit = (e) => {
    e.preventDefault();

    setSearch({
      searchYear: e.target.ano.value,
      searchName: e.target.nombre.value,
      status: true,
    });
  };

  return (
    <div className="col-xl-12">
      <div className="card">
        <div className="card-header">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label fw-bolder text-dark">
              FILTROS DE BÚSQUEDA
            </span>
          </h3>
        </div>
        <div className="card-body">
          <form
            data-kt-search-element="advanced-options-form"
            className="pt-1"
            onSubmit={handleSubmit}
          >
            <div className="row mb-8">
              <div className="col-4">
                <select
                  name="ano"
                  className="form-select"
                  aria-label="Select example"
                >
                  <option value="">Seleccionar...</option>
                  <option value="2022">2022</option>
                  <option value="2023">2023</option>
                  <option value="2024">2024</option>
                  <option value="2025">2025</option>
                  <option value="2026">2026</option>
                  <option value="2027">2027</option>
                </select>
              </div>

              <div className="col-4">
                <input
                  type="text"
                  name="nombre"
                  className="form-control"
                  placeholder="Nombre del proceso"
                />
              </div>

              <div className="col-4">
                <button type="submit" className="btn btn-primary me-5">
                   Buscar Proceso
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default Buscar;
